export default __webpack_public_path__ + "static/media/logout_white_24dp.3b92f307.svg";